import { render } from "./ModalDemo.vue?vue&type=template&id=7aaef487"
import script from "./ModalDemo.vue?vue&type=script&lang=js"
export * from "./ModalDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__